import { render, staticRenderFns } from "./Range.vue?vue&type=template&id=636536b4"
import script from "./Range.vue?vue&type=script&lang=js"
export * from "./Range.vue?vue&type=script&lang=js"
import style0 from "./Range.vue?vue&type=style&index=0&id=636536b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports